import React from 'react';
import { CheckCircle, AlertTriangle, MessageCircle, X } from 'lucide-react';

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div style={{ zIndex: 99999999 }} className="fixed top-24 right-5 flex flex-col gap-3 w-full max-w-sm pointer-events-none">
      {toasts.map((toast) => (
        <div key={toast.id} className={`pointer-events-auto flex items-start gap-3 p-4 rounded-xl shadow-2xl border-l-8 text-white transform transition-all duration-300 animate-in slide-in-from-right ${toast.type === 'success' ? 'bg-gray-800 border-green-500' : toast.type === 'error' ? 'bg-gray-800 border-red-500' : 'bg-gray-800 border-amber-500'}`}>
          <div className="mt-0.5">
            {toast.type === 'success' ? <CheckCircle size={20} className="text-green-500" /> :
             toast.type === 'error' ? <AlertTriangle size={20} className="text-red-500" /> :
             <MessageCircle size={20} className="text-amber-500" />} 
          </div>
          <div className="flex-1">
            <h4 className={`font-bold text-sm ${toast.type === 'success' ? 'text-green-400' : 'text-white'}`}>{toast.title}</h4>
            <p className="text-xs text-gray-300 mt-1 leading-snug">{toast.message}</p>
          </div>
          <button onClick={() => removeToast(toast.id)} className="text-gray-500 hover:text-white"><X size={16} /></button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;